import { getItemsDedicatedUrl } from './getItemsDedicatedUrl';

export const getShareableData = ({ item, parentType, currentUrl }) => {
  const url = getItemsDedicatedUrl({
    item,
    liveFeedType: parentType,
    currentUrl,
  });

  switch (item.type) {
    case 'communications_post_communication':
    case 'communications_news':
      return {
        text: item.subject,
        url,
      };
    case 'ventures_venture':
      return {
        text: item.company_name,
        url,
      };
    case 'event':
    case 'network_events_event':
    case 'business_opportunities_request':
      return {
        text: item.title,
        url,
      };
    default:
      return { url };
  }
};
